import React, { useContext, useState } from 'react'
import { UserContext } from '../../Context/User'
import { StoresContext } from '../../Context/Stores'
import { API_URL, fetchCfg } from '../../../config'
import SVG from '../../SVG'
import Error from '../../Error'
import Checkbox from '../../Checkbox'
import { createFileName, downloadBlob, fromLocalStorage } from '../../../common'
import Plausible from '../../../Plausible-dummy'

const { trackEvent } = Plausible()

const BrandsDownload = () => {
  const user = useContext(UserContext)
  const storesCtx = useContext(StoresContext)
  const { store, channel } = storesCtx

  /* "Remember" the user's column seclections */
  const getColumnDefaultsFromLocalStorage = () => {
    const savedColumns = fromLocalStorage('brandColumns') || {}
    delete savedColumns.template
    return {
      name: true,
      page_title: true,
      meta_keywords: true,
      meta_description: true,
      image_url: true,
      search_keywords: true,
      custom_url: true,
      ...savedColumns,
    }
  }

  const [formData, setFormData] = useState(getColumnDefaultsFromLocalStorage())
  const [waiting, setWaiting] = useState(false)
  const [error, setError] = useState(null)

  const handleCheck = (event) => {
    const { id, checked } = event?.target
    setFormData((formData) => ({ ...formData, [id]: checked }))
    setError(null)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
  }

  const runTool = async () => {
    setWaiting(true)
    trackEvent('Brands download')
    localStorage.setItem('brandColumns', JSON.stringify(formData))
    await downloadFile()
    setWaiting(false)
  }

  const downloadFile = async () => {
    setError(null)
    let res
    try {
      res = await fetch(`${API_URL}/${store.bc_hash}/${channel.id}/brands/export`, {
        ...fetchCfg(user.csrfToken),
        method: 'post',
        body: JSON.stringify(formData),
      })
      if (res.status === 200) {
        const fileBlob = await res.blob()
        downloadBlob(fileBlob, createFileName('brands', store.bc_hash, 'csv'))
        return
      }
      const data = await res.json()
      setError(data.error)
    } catch (err) {
      console.error(res)
      setError('Something went wrong')
    }
  }

  const disabled = !user.authenticated || !store.bc_hash

  return (
    <div className="">
      <div className="flex-1 border-b border-gray-200 mb-4">
        <h5 className="text-3xl leading-6 font-semibold text-gray-900 flex items-center mt-0">
          <span className="text-indigo-600">
            <SVG name="brands" size={54} lineWidth={1.5} />
          </span>
          <div className="pl-2 flex items-end">
            Brands
            {store.summary && (
              <span className="bg-gray-200 rounded text-sm px-2 text-gray-600 ml-2">
                {store.summary.brands_count?.toLocaleString()}
              </span>
            )}
          </div>
        </h5>
      </div>

      <form method="post" action="#" onSubmit={handleSubmit}>
        <div className="pt-4">
          <div className="font-bold text-lg">Download brands</div>
          <div className="text-sm text-gray-500">
            Columns to include in download...
          </div>
        </div>
        <div className="mt-6 items-center justify-between">
          <Checkbox
            key="id"
            id="id"
            value={true}
            onChange={handleCheck}
            disabled={true}
          />

          {Object.keys(formData).map((id) => (
            <Checkbox
              key={id}
              id={id}
              value={formData[id]}
              onChange={handleCheck}
            />
          ))}
        </div>

        {error && <Error msg={error} />}

        <div className="mt-2">
          <span className="block w-full py-4">
            <button
              onClick={runTool}
              disabled={disabled}
              type="button"
              className={`flex items-center justify-center py-2 px-4 border border-transparent text-lg font-medium rounded-md text-white ${
                disabled ? 'bg-gray-500' : 'bg-blue-600'
              } ${
                !disabled && 'hover:bg-blue-500'
              } focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition duration-150 ease-in-out`}
            >
              {waiting ? (
                <SVG name="spinner" size={32} />
              ) : (
                <SVG name="download" size={32} lineWidth={1} />
              )}
              <div className="ml-2">Download</div>
            </button>
          </span>
        </div>
        <div className="px-1 py-2 rounded-md opacity-70">
          <div className="flex items-center">
            <span className="text-gray-500">
              <SVG name="info" size={16} />
            </span>
            <div className="ml-3">
              <p className="text-xs text-gray-500">
                It may take several seconds for your CSV file to be generated
                and start downloading.
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default BrandsDownload
